import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["theme", "loading", "size", "children", "beforeIcon", "fullWidth"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { clsx as cx } from 'clsx';
import { getTheme } from '../../themes';
import { Spinner } from '../../../loader';
import * as customStyles from '../../styles/button.module.css';
import * as styles from '../../styles/shared.module.css';

/**
 * Компоненты кнопки. <br />
 * Компонет имеет настройки тем, размеров, умеет отображать прелоадер, иконки и текст. Кроме того кнопки меняют свое отображение в завсимости от пользовательских действий.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ButtonComponent = /*#__PURE__*/React.forwardRef(function Button(props, ref) {
  var _cx;
  var theme = props.theme,
    loading = props.loading,
    size = props.size,
    children = props.children,
    beforeIcon = props.beforeIcon,
    fullWidth = props.fullWidth,
    rest = _objectWithoutProperties(props, _excluded);
  var themeClasses = getTheme(theme);
  var buttonClasses = cx(styles['button'], customStyles['button'], styles[size], themeClasses['button'], (_cx = {}, _defineProperty(_cx, customStyles['loading'], loading), _defineProperty(_cx, styles['full-width'], fullWidth), _cx));
  return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
    className: buttonClasses
  }, rest), {}, {
    ref: ref,
    children: [loading && /*#__PURE__*/_jsx("span", {
      className: cx(styles['spinner'], customStyles['spinner'], themeClasses['spinner']),
      children: /*#__PURE__*/_jsx(Spinner, {
        color: "current_color",
        size: 16
      })
    }), beforeIcon, children && /*#__PURE__*/_jsx("span", {
      className: styles['text'],
      children: children
    })]
  }));
});
ButtonComponent.defaultProps = {
  theme: 'fill_primary',
  size: 'M',
  loading: false,
  beforeIcon: undefined
};
export var Button = /*#__PURE__*/React.memo(ButtonComponent);